import { render, staticRenderFns } from "./ManualTransactionCell.vue?vue&type=template&id=1f5d23e0&"
import script from "./ManualTransactionCell.vue?vue&type=script&lang=babel&"
export * from "./ManualTransactionCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports